var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { t } from '@lingui/core/macro';
import { Avatar, AvatarLetter, AvatarList, AvatarListHeader, Skeleton, TableBodyCell, TableCellEmpty, TeamAvatar, UserAvatar, } from '@pocketlaw/tetris';
import { useTeams } from './useTeams';
import { useUsers } from './useUsers';
export function UserAndTeamsCell(props) {
    const { userIds, teamIds } = props, rest = __rest(props, ["userIds", "teamIds"]);
    const { users, loading: loadingUsers } = useUsers(userIds !== null && userIds !== void 0 ? userIds : []);
    const { teams, loading: loadingTeams } = useTeams(teamIds !== null && teamIds !== void 0 ? teamIds : []);
    const loading = loadingUsers || loadingTeams;
    if (loading) {
        return (<TableBodyCell {...rest}>
        <Skeleton loading borderRadius="circle">
          <Avatar size="sm" shape="circle" appearance="light">
            <AvatarLetter>?</AvatarLetter>
          </Avatar>
        </Skeleton>
      </TableBodyCell>);
    }
    if (!users.length) {
        return (<TableBodyCell {...rest}>
        <TableCellEmpty />
      </TableBodyCell>);
    }
    return (<TableBodyCell {...rest}>
      <AvatarList>
        <AvatarListHeader title={t({
            message: 'Users',
            comment: 'Search results table - Project members cell',
        })}/>
        {users.map((user) => (<UserAvatar key={user.id} title={user.name}/>))}
        <AvatarListHeader title={t({
            message: 'Teams',
            comment: 'Search results table - Project members cell',
        })}/>
        {teams.map((team) => (<TeamAvatar key={team.id} title={team.name}/>))}
      </AvatarList>
    </TableBodyCell>);
}
